// import riskImg from '../../images/services/risk.jpg';
import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const RiskManagementAndInternalControls = () => {
  const serviceData = {
    title: "Risk Management & Internal Controls",
    heading: "Risk Management & Internal Controls",
    image: subTopicImages["Risk Management & Internal Controls"],
    intro: "",
    description: [
      "We strengthen the organisation’s control environment through IFC frameworks, policy & SOP design, governance advisory, internal control reviews and risk-management programs — supporting audit readiness, compliance comfort and leadership assurance.",
    ],
    services: [],
    benefitsIntro: "",
    benefits: [],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default RiskManagementAndInternalControls;
